import USDt from "../common/usdt";

export const assetUSDt = {
  id: 1984,
  height: 1129161,
  ...USDt,
};
